import React, { useState } from 'react'
import { Row, Form, Card, Col, Container, Button} from 'react-bootstrap'
import { uid } from 'uid';

import '../Estado/Estados.css'

export const CZDeck = ({czs, programa, resetEstado}) => {

    const [state, setState] = useState(czs);

    const buscarCZ = (e) => {

        let busqueda = e.target.value;
        busqueda = busqueda.toUpperCase();
        setState(czs.filter(cz => cz.cdescz.includes(busqueda.toUpperCase())));
    }

    const regresarNacional = (e) => {
        resetEstado(0);
    }


    return (
        <Container fluid className="animate__animated animate__fadeIn">
            <br />
            <br />
            <br />
            <Button onClick={regresarNacional} block variant="secondary" >Volver a Nacional</Button>
            <br />
            <Form.Control type="search" as="input" placeholder="Buscar CZ" onChange={buscarCZ}/>
            <br />
            <Row >

                {
                    programa === "PR"?
                    (
                        state.map(({icvecz, cdescz, ucn, participantes, exa_pre_papel, exa_acre_papel, diag_pre_papel, diag_acre_papel,exa_pre_linea,exa_acre_linea,diag_pre_linea,diag_acre_linea,porc_acre,incorp,reincorp}) => {
                            return <Col sm={6} xs={12} className="pb-4" key={uid()} >
                                <Card>
                                    <Card.Header bsPrefix="tarjeta-header2" > {icvecz} | {cdescz} </Card.Header>
                                    <Card.Body style={{color: "#6F7271"}}>
                                        <Row>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header incorp" >PARTICIPANTES</h2>
                                                <h4 className="texto-body incorp"> {participantes} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header incorp" >CONCLUSIONES</h2>
                                                <h4 className="texto-body incorp"> {ucn} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header incorp" >INCORPORACIONES</h2>
                                                <h4 className="texto-body incorp"> {incorp} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header incorp" >REINCORPORACIONES</h2>
                                                <h4 className="texto-body incorp"> {reincorp} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header pres" >EXA_PRE_PAPEL</h2>
                                                <h4 className="texto-body pres"> {exa_pre_papel} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header acre" >EXA_ACRE_PAPEL</h2>
                                                <h4 className="texto-body acre"> {exa_acre_papel} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header pres" >DIAG_PRE_PAPEL</h2>
                                                <h4 className="texto-body pres"> {diag_pre_papel} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header acre" >DIAG_ACRE_PAPEL</h2>
                                                <h4 className="texto-body acre"> {diag_acre_papel} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header pres" >EXA_PRE_LINEA</h2>
                                                <h4 className="texto-body pres"> {exa_pre_linea} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header acre" >EXA_ACRE_LINEA</h2>
                                                <h4 className="texto-body acre"> {exa_acre_linea} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header pres" >DIAG_PRE_LINEA</h2>
                                                <h4 className="texto-body pres"> {diag_pre_linea} </h4>
                                            </Col>
                                            <Col lg={4} sm={6} className="pb-2">
                                                <h2 className="texto-header acre" >DIAG_ACRE_LINEA</h2>
                                                <h4 className="texto-body acre"> {diag_acre_linea} </h4>
                                            </Col>
                                            <Col xl={12} className="pb-2">
                                                <h2 className="texto-header acre" >ACREDITACIÓN</h2>
                                                <h4 className="texto-body acre"> {porc_acre} </h4>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        })
                    ) :
                    (
                        state.map(({icvecz,cdescz,participantes,incorp,exa_pre_papel,exa_acre_papel,exa_pre_linea,exa_acre_linea,porc_acre}) => {
                            return <Col sm={6} xs={12} className="pb-4" >
                            <Card>
                                <Card.Header bsPrefix="tarjeta-header2" > {icvecz} | {cdescz} </Card.Header>
                                <Card.Body style={{color: "#6F7271"}}>
                                    <Row>
                                        <Col lg={4} sm={6} className="pb-2">
                                            <h2 className="texto-header incorp" >PARTICIPANTES</h2>
                                            <h4 className="texto-body incorp"> {participantes} </h4>
                                        </Col>
                                        <Col lg={4} sm={6} className="pb-2">
                                            <h2 className="texto-header incorp" >INCORPORACIONES</h2>
                                            <h4 className="texto-body incorp"> {incorp} </h4>
                                        </Col>
                                        <Col lg={4} sm={6} className="pb-2">
                                            <h2 className="texto-header pres" >EXA_PRE_PAPEL</h2>
                                            <h4 className="texto-body pres"> {exa_pre_papel} </h4>
                                        </Col>
                                        <Col lg={4} sm={6} className="pb-2">
                                            <h2 className="texto-header acre" >EXA_ACRE_PAPEL</h2>
                                            <h4 className="texto-body acre"> {exa_acre_papel} </h4>
                                        </Col>
                                        <Col lg={4} sm={6} className="pb-2">
                                            <h2 className="texto-header pres" >EXA_PRE_LINEA</h2>
                                            <h4 className="texto-body pres"> {exa_pre_linea} </h4>
                                        </Col>
                                        <Col lg={4} sm={6} className="pb-2">
                                            <h2 className="texto-header acre" >EXA_ACRE_LINEA</h2>
                                            <h4 className="texto-body acre"> {exa_acre_linea} </h4>
                                        </Col>
                                        <Col xl={12} className="pb-2">
                                            <h2 className="texto-header acre" >ACREDITACIÓN</h2>
                                            <h4 className="texto-body acre"> {porc_acre} </h4>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        })
                    )
                }

            </Row>
        </Container>
    )
}
